/* eslint-disable */

import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'
import { useReducedMotion } from 'framer-motion'

// Color mapping for equity caps
const COLORS = ['#2818ff', '#d4f54d', '#4c4eff']
export const EQUITY_COLOR_MAP = {
  'Large Cap': '#2818ff',
  'Mid Cap': '#d4f54d',
  'Small Cap': '#4c4eff',
}

const EquityCapChart = ({ equityCapData, hideTitle = false, hideCard = false }) => {
  const shouldReduceMotion = useReducedMotion()

  // Format currency in Indian number system
  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount)
  }

  // Format percentage to 2 decimal places
  const formatPercentage = (percentage) => {
    return parseFloat(percentage).toFixed(2)
  }

  // Prepare data for chart
  const chartData = [
    {
      name: 'Large Cap',
      value: equityCapData.largeCap.percentage,
      amount: equityCapData.largeCap.amount,
    },
    {
      name: 'Mid Cap',
      value: equityCapData.midCap.percentage,
      amount: equityCapData.midCap.amount,
    },
    {
      name: 'Small Cap',
      value: equityCapData.smallCap.percentage,
      amount: equityCapData.smallCap.amount,
    },
  ]

  // Custom label for the chart
  const renderCustomLabel = (entry) => {
    return `${formatPercentage(entry.value)}%`
  }

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload
      return (
        <div className='bg-white px-4 py-3 rounded-lg shadow-lg border border-gray-200'>
          <p className='text-sm text-gray-900 mb-1'>{data.name}</p>
          <p className='text-sm text-gray-600 tabular-nums'>{formatIndianCurrency(data.amount)}</p>
          <p className='text-sm text-gray-600 tabular-nums'>{formatPercentage(data.value)}%</p>
        </div>
      )
    }
    return null
  }

  const content = (
    <>
      {!hideTitle && (
        <div className='px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200'>
          <h2 className='text-base sm:text-lg'>Indian Equity Market Cap Distribution</h2>
        </div>
      )}

      <div className={hideTitle ? 'py-4 sm:py-6' : 'px-4 sm:px-6 py-4 sm:py-6'}>
        <style
          dangerouslySetInnerHTML={{
            __html: `
                        .recharts-pie-sector:focus,
                        .recharts-pie-sector path:focus,
                        .recharts-wrapper svg:focus,
                        .recharts-wrapper:focus {
                            outline: none !important;
                        }
                        .recharts-pie-sector {
                            outline: none !important;
                        }
                    `,
          }}
        />
        <ResponsiveContainer width='100%' height={260} className='sm:hidden'>
          <PieChart margin={{ top: 8, right: 18, bottom: 8, left: 18 }}>
            <Pie
              data={chartData}
              cx='50%'
              cy='48%'
              labelLine={false}
              label={renderCustomLabel}
              outerRadius={72}
              innerRadius={46}
              fill='#8884d8'
              dataKey='value'
              paddingAngle={2}
              activeIndex={undefined}
              activeShape={false}
              isAnimationActive={!shouldReduceMotion}
              animationBegin={100}
              animationDuration={700}
              animationEasing='ease-out'
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>

        <ResponsiveContainer width='100%' height={400} className='hidden sm:block'>
          <PieChart margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
            <Pie
              data={chartData}
              cx='50%'
              cy='40%'
              labelLine={false}
              label={renderCustomLabel}
              outerRadius={80}
              innerRadius={50}
              fill='#8884d8'
              dataKey='value'
              paddingAngle={2}
              activeIndex={undefined}
              activeShape={false}
              isAnimationActive={!shouldReduceMotion}
              animationBegin={100}
              animationDuration={700}
              animationEasing='ease-out'
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </>
  )

  if (hideCard) {
    return content
  }

  return (
    <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden'>
      {content}
    </div>
  )
}

export default EquityCapChart
